import { memo } from 'react';
import { ChevronLeft, ChevronRight, Keyboard } from 'lucide-react';

interface ViewerFooterProps {
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
  hintText?: string;
}

function ViewerFooterInner({ currentPage, totalPages, onPageChange, hintText }: ViewerFooterProps) {
  const hasPages = currentPage != null && totalPages != null && totalPages > 1 && onPageChange;

  return (
    <footer className="bg-white border-t border-[#f0d2f0]/50 px-4 py-2 shrink-0 safe-area-bottom">
      <div className="flex items-center justify-between gap-2">
        {hasPages ? (
          <>
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage <= 1}
              className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-[#8e4585] hover:bg-[#f8e8f8] active:bg-[#f0d2f0] text-xs font-medium disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronLeft size={14} />
              Previous Page
            </button>
            <span className="text-[#5a3d58] text-xs font-medium">
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
              className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-[#8e4585] hover:bg-[#f8e8f8] active:bg-[#f0d2f0] text-xs font-medium disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
              Next Page
              <ChevronRight size={14} />
            </button>
          </>
        ) : (
          <div className="flex items-center justify-center w-full gap-1.5 text-[#8e4585]/50 text-[10px]">
            <Keyboard size={11} />
            <span>{hintText || 'Press Esc to close'}</span>
          </div>
        )}
      </div>
    </footer>
  );
}

export const ViewerFooter = memo(ViewerFooterInner);
